import React, { useState, useEffect } from 'react'
import { useQuery, useMutation } from 'react-apollo-hooks'
import { Modal, Loader } from '../../application'
import WizardStep1 from './WizardStep1'
import WizardStep2 from './WizardStep2'
import WizardStep3 from './WizardStep3'
import WizardStep4 from './WizardStep4'
import WizardHeader from './WizardHeader'
import WizardFooter from './WizardFooter'
import getText from '../strings'
import styled from 'react-emotion'
import { colors } from '../../styles'
import * as Queries from '../queries'
import * as Mutations from '../mutations'
import { useAuth } from '../../authContext'

const Flex = styled('div')`
  display: flex;
  justify-content: space-between;
  align-items: center;
  a {
    color: ${colors.tui_red};
    cursor: pointer;
  }
  @media (max-width: 992px) {
    flex-direction: column;
    align-items: flex-start;
    a {
      margin-top: 10px;
      display: block;
    }
  }
`

export default ({ caseType, header, description, actionLabel, wizardHeading }) => {
  const { actions, profile } = useAuth()
  const [mobile, setMobile] = useState(null)
  const [bookingNumbers, setBookingNumbers] = useState([])
  const [currentStep, setCurrentStep] = useState(1)
  const [file, setfile] = useState({})
  const [error, setError] = useState(false)
  const [sending, setSending] = useState(false)
  const [submitted, setSubmitted] = useState(false)
  const [formData, setFormData] = useState({
    email: profile.email,
    lastName: profile.lastName,
    firstName: profile.firstName,
    loaded: false
  })

  const { loading, data } = useQuery(Queries.getPrivacy())
  const createCustomerCase = useMutation(Mutations.createCustomerCase)

  useEffect(() => {
    if (!loading && data.bookings) {
      setMobile(data.contactDetails && data.contactDetails.phoneNumber)
      setBookingNumbers(data.bookings.map(p => p.bookingNumber))
      setFormData({
        ...formData,
        mobile: data.contactDetails && data.contactDetails.phoneNumber,
        bookingNumbers: data.bookings.map(p => p.bookingNumber),
        loaded: true
      })
    }
  }, [loading, data])

  const submitData = () => {
    setError(false)
    setSending(true)
    createCustomerCase({
      variables: {
        caseType,
        file,
        data: {
          email: formData.email,
          lastName: formData.lastName,
          firstName: formData.firstName,
          mobile: formData.mobile,
          bookingNumbers: formData.bookingNumbers
        }
      },
      update: (proxy, mutationResult) => {
        setError(!mutationResult.data.createCustomerCase)
        setSubmitted(mutationResult.data.createCustomerCase)
        setCurrentStep(4)
      }
    })
  }

  if (!formData.loaded) {
    return <Loader />
  }

  const handleModalClose = () => {
    if (submitted && caseType === 'forgetme') {
      actions.logout()
    }
    setFormData({
      email: profile.email,
      lastName: profile.lastName,
      firstName: profile.firstName,
      mobile: mobile,
      bookingNumbers: bookingNumbers,
      loaded: true
    })
    setCurrentStep(1)
  }

  const handleStep1Click = (data) => {
    setCurrentStep(2)
    setFormData(data)
  }
  const handleStep2Click = (file) => {
    setCurrentStep(3)
    setfile(file)
  }

  return (
    <Flex>
      <div>
        <h4>{header}</h4>
        <div>{description}</div>
        <div>{getText('case', 'processTimeForCase')}:&nbsp;<strong>{getText('case', 'processTime')}</strong></div>
      </div>
      <Modal onClose={handleModalClose} easyClose={false} Opener={() => <a>{actionLabel}</a>}>
        {currentStep !== 4 && <WizardHeader header={wizardHeading} steps={[getText('case', 'yourDetails'), getText('case', 'material'), getText('case', 'summary')]} currentStep={currentStep} />}
        {currentStep === 1 && <WizardStep1 caseType={caseType} initialValues={formData} onNextClick={data => handleStep1Click(data)} />}
        {currentStep === 2 && <WizardStep2 caseType={caseType} onBackClick={() => setCurrentStep(1)} onNextClick={data => handleStep2Click(data)} />}
        {currentStep === 3 && <WizardStep3 sending={sending} formData={formData} file={file} onBackClick={() => setCurrentStep(2)} onNextClick={submitData} />}
        {currentStep === 4 && <WizardStep4 signOut={actions.logout} error={error} caseType={caseType} email={formData.email} />}
        {currentStep !== 4 && <WizardFooter />}
      </Modal>
    </Flex>
  )
}